<template>
    <div>
        <card-header title="Manage Payout" icon="fa-money-check-dollar-pen"/>

        <div class="custom-toolbar" v-if="!review">
            <div class="columns">
                <div class="column">
                    <b-field label="Start Date" label-position="inside">
                        <b-datepicker append-to-body v-model="startDate" :min-date="minDate" @input="changeDate"/>
                    </b-field>
                </div>
                <div class="column">
                    <b-field label="End Date" label-position="inside">
                        <b-datepicker append-to-body v-model="endDate" :min-date="minDate" @input="changeDate"/>
                    </b-field>
                </div>
<!--                <div class="column">-->
<!--                    <b-field>-->
<!--                        <b-switch size="is-small" v-model="hideCompleted">Hide Completed</b-switch>-->
<!--                    </b-field>-->
<!--                </div>-->
            </div>
        </div>

        <card-body>
            <card-list>
                <template v-for="c in conferences">
                    <subheader-list-item
                        :title="c.title"
                        icon="fa-users-class"
                        :badge="c.registrations.length"
                        v-if="c.registrations && c.registrations.length > 0"
                    />
                    <revenue-registration-tile
                        v-for="r in c.registrations"
                        :registration="r"
                        :card="card"
                    />
                </template>
            </card-list>
        </card-body>

        <card-footer class="pt-3 pb-3" v-if="!review">

            <div class="columns">
                <div class="column">
                    <div class="is-size-7" v-if="currentUser.isSuper">Total: <strong>{{ total| currency }} </strong>({{count}} registrations)</div>
                </div>
                <div class="column has-text-right">
                    <b-button
                        type="is-info"
                        size="is-small"
                        class="mr-3"
                        @click="reviewChanges()"
                        disabled="disabled"
                    ><i class="fas fa-check mr-2"></i>Request Payout
                    </b-button>
                </div>
            </div>
        </card-footer>

        <card-footer class="pt-3 pb-3" v-else>

            <div class="columns">
                <div class="column">
<!--                    <div class="is-size-4"><strong>{{ toggleDelta | currency }}</strong></div>-->
                </div>
                <div class="column has-text-right">
                    <b-button outlined size="is-small" @click="review=false" class="mr-3">Cancel</b-button>
                    <b-button
                        type="is-danger"
                        size="is-small"
                        class="mr-3"
                        :disabled="!changed"
                        @click="process()"
                    ><i class="fas fa-check mr-2"></i>Process
                    </b-button>
                </div>
            </div>
        </card-footer>
    </div>
</template>

<script>
    import CardHeader from "@/TIER/components/CardHeader";
    import CardBody from "@/TIER/components/CardBody";
    import CardList from "@/TIER/components/CardList";
    import SubheaderListItem from "@/TIER/components/SubheaderListItem";
    import SearchListItem from "@/TIER/components/SearchListItem";

    import {client as http} from '@/http_client';
    import { mapGetters } from "vuex";

    import ContainerListItem from "../../TIER/components/ContainerListItem";
    import CardToolbar from "../../TIER/components/CardToolbar";
    import moment from 'moment';
    import CardFooter from "../../TIER/components/CardFooter";
    import ResellerReferralTile from "../../components/tiles/ResellerReferralTile";
    import RevenueRegistrationTile from "../../components/tiles/RevenueRegistrationTile.vue";

    export default {
        components: {RevenueRegistrationTile, ResellerReferralTile, CardFooter, CardToolbar, ContainerListItem, CardHeader, CardBody, CardList, SubheaderListItem, SearchListItem},
        props: ['card', 'props', 'child'],

        data() {
            return {
                conferences: [],
                startDate: moment().set('date', 1).toDate(),
                endDate: new Date(),
                // hideCompleted: true,
                review: false,
                minDate: new Date(new Date().setYear(new Date().getFullYear() - 3)),
            };
        },
        computed: {
            ...mapGetters(['currentUser']),
            total() {
                return this.conferences.reduce((acc, c) => {
                    return acc + c.registrations.reduce((acc, r) => {
                        return acc + parseInt(r.revenue);
                    }, 0);
                }, 0);
            },
            count() {
                return this.conferences.reduce((acc, c) => {
                    return acc + c.registrations.length;
                }, 0);
            },
        },
        methods: {
            loadReport: function() {
                this.$emit('loading', true);
                this.referrals = [];
                this.reseller = null;

                http.post('organizations/payout-report', {start: this.startDate, end: this.endDate}).then(response => {
                    this.conferences = response.data.conferences;
                    this.$emit('loading', false);
                });
            },
            changeDate: function() {
                this.loadReport();
            },
            reviewChanges: function() {
                this.review = true;
            },
            process: function() {
                this.$emit('loading', true);
                let referrals = [];
                for (let i = 0; i < this.referrals.length; i++) {
                    const r = this.referrals[i];
                    if (r.toggle !== r.paid) referrals.push({
                        id: r.id,
                        firstName: r.firstname,
                        lastName: r.lastname,
                        date: moment(r.enrollDate).format('MMM Do, YYYY'),
                        type: r.type,
                        calc: (r.toggle) ? r.calc : r.calc*-1,
                        paid: r.toggle
                    });
                }

                let payload = {
                    reseller: {
                        firstName: this.reseller.first_name,
                        lastName: this.reseller.last_name
                    },
                    referrals
                };

                http.post('resellers/referrals/process', payload, {force: true}).then(response => {
                    this.$saveAlert(false);
                    this.$closeCard(this.card);
                });
            },
            searchClient: function(query) {
                this.searchQuery = query;
            }
        },
        mounted: function() {
            this.startDate = moment().subtract(12, 'month').set('date', 1).set('hour', 0).set('minute', 0).set('second', 0).toDate();
            this.endDate = moment().set('hour', 23).set('minute', 59).set('second', 59).toDate();
            this.$saveAlert(true, 'Are you done editing this report? Unsaved changes will be lost.');
            this.loadReport();
        }
    };
</script>

<style lang="scss" scoped>
    .custom-toolbar {
        background: #f3f3f3;
        border-bottom: 1px solid #dee2e6;

        padding: 10px 0.4rem 10px 0.6rem;
    }
</style>
